import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaMapMarkerAlt, FaUsers, FaStar, FaArrowRight } from 'react-icons/fa';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import '../../../assets/css/customer/venues/VenueCardsSection.css';

const VCS_INITIAL_COUNT = 6; // 2 rows of 3 (lg={4})

const VenueCardsSection = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);

  const [venues, setVenues] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [loadingId, setLoadingId] = useState(null);
  const [visibleCount, setVisibleCount] = useState(VCS_INITIAL_COUNT);

  const viewAllVenue = () => {
    setPageLoading(true);
    axios.get(`${baseUrl}/venues/viewAllVenue`)
    .then((res) => setVenues(res.data))
    .catch((err) => console.log(err))
    .finally(() => setPageLoading(false));
  };

  useEffect(() => {
    viewAllVenue();
  }, []);

  const handleViewDetail = (venue) => {
    setLoadingId(venue.id); // 
    setTimeout(() => {
      navigate('/venue-details', { state: { venue } });
      setLoadingId(null);
    }, 600); 
  };

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + VCS_INITIAL_COUNT);
  };

  const visibleVenues = venues.slice(0, visibleCount);

  return (
    <section className="vcs-section">
      <Container>
        <Row className="vcs-header-row">
          <Col xs={12} className="text-center">
            <p className="vcs-section-label">Featured Venues</p>
            <h2 className="vcs-section-heading">
              Discover Perfect <span className="vcs-highlight">Wedding Venues</span>
            </h2>
            <p className="vcs-section-description">
              Browse our collection of stunning venues for your special day
            </p>
          </Col>
        </Row>

        {pageLoading ? (
          <Row>
            <Col xs={12} className="text-center" style={{ padding: "60px 0" }}>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
              Loading venues...
            </Col>
          </Row>
        ) : (
          <>
            <Row className="g-4">
              {visibleVenues.length === 0 && (
                <Col xs={12} className="text-center" style={{ padding: "40px 0" }}>
                  No venues found
                </Col>
              )}
              {visibleVenues.map((venue) => (
                <Col key={venue.id} xs={12} sm={6} lg={4}>
                  <div className="vcs-card">
                    <div className="vcs-card-img-wrapper">
                      <img src={venue.coverImage} alt={venue.venueName} className="vcs-card-img" />
                      {/* <div className="vcs-rating-badge">
                        <FaStar className="vcs-star-icon" />
                        <span>{venue.rating}</span>
                      </div> */}
                    </div>

                    <div className="vcs-card-body">
                      <span className="vcs-city-badge">{venue.city}</span>
                      <h3 className="vcs-card-name">{venue.venueName}</h3>
                      <p className="vcs-card-location">
                        <FaMapMarkerAlt className="vcs-location-icon" />
                        {venue.location}
                      </p>
                      <p className="vcs-card-capacity">
                        <FaUsers className="vcs-capacity-icon" />
                        Capacity: {venue.capacity} guests
                      </p>
                      <p className="vcs-card-price">{venue.priceRange}</p>
                      <hr className="vcs-card-divider" />

                      <button
                        className="vcs-detail-btn"
                        onClick={() => handleViewDetail(venue)}
                        disabled={loadingId === venue.id}
                      >
                        {loadingId === venue.id ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            />
                            Loading...
                          </>
                        ) : (
                          <>
                            View Detail
                            <FaArrowRight className="vcs-btn-icon" />
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>

            {visibleCount < venues.length && (
              <Row>
                <Col xs={12} className="text-center" style={{ marginTop: "30px" }}>
                  <Button variant="outline-primary" onClick={handleLoadMore}>
                    Load More
                  </Button>
                </Col>
              </Row>
            )}
          </>
        )}
      </Container>
    </section>
  );
};

export default VenueCardsSection;